<template>
  <div>
    <div class="header-v1-wrap">
      <div class="header-wrap">
        <div class="top-header-wrap d-block primary">
          <div class="top-header">
            <v-container>
              <v-layout align-center justify-space-between>
                <!-- v-if="deviceType != 'mobile' && deviceType != 'tablet'" -->
                <div class="header d-md-inline-flex align-items-center">
                  <div class="site-logo d-inline-block">
                    <router-link to="/">
                      <img
                        alt="site-logo"
                        height="34"
                        :src="topbarSection.Logo_PNG_Image_224x34_px"
                        width="224"
                      />
                    </router-link>
                  </div>
                </div>

                  <!-- Search box -->
                <div class="d-md-inline-flex align-items-center">
                  <div class="hidden-sm-and-down adjust-size">
                    <v-text-field
                      outlined
                      dark
                      append-icon="search"
                    ></v-text-field>
                    <!-- <input outlined  append-icon="search"
                      type="text"
                      id="globalSearchInputBox"
                      placeholder="Search Here1"
                    /> -->
                  </div>
                </div>

                <div class="notifications d-inline-flex align-items-center">
                  <emb-currency
                    class="hidden-sm-and-down"
                    :topbarArea="topbarSection"
                  ></emb-currency>
                  <emb-lang
                    class="hidden-sm-and-down"
                    :topbarArea="topbarSection"
                  ></emb-lang>
                  <emb-cart :data="topbarSection"></emb-cart>
                  <emb-wishlist :data="topbarSection"></emb-wishlist>
                  <emb-user-block :data="topbarSection"></emb-user-block>
                </div>
              </v-layout>
            </v-container>
          </div>
        </div>
        <div class="bottom-header d-block primary">
          <v-container>
            <div class="bottom-header-inner">
              <div class="menu-alignment">
                <emb-menu ref="menubar"></emb-menu>
              </div>
              <div class="layout align-left responsive-menu">
                <v-btn
                  icon
                  dark
                  @click="toggleMobileSidebar"
                  class="toggle-btn"
                  large
                >
                  <i class="material-icons">menu</i>
                </v-btn>
              </div>
              <!-- <emb-search></emb-search> -->
              <div class="search-box align-right" style="width:83%">
                <!-- Search box -->
                <!-- <v-flex xs12 sm12 md4 lg3 xl2>  -->
                <div class="mob-search hidden-md-and-up">
                  <v-text-field
                    outlined
                    dark
                    append-icon="search"
                  ></v-text-field>
                </div>
                <!-- </v-flex> -->
              </div>
            </div>
          </v-container>
        </div>
      </div>
    </div>
    <div id="fixedHeader">
      <emb-fixed-header
        :headerLogo="topbarSection.Logo_PNG_Image_224x34_px"
      ></emb-fixed-header>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Menu from "./Menu";
import Lang from "./Lang";
import Currency from "./Currency";
import Cart from "./Cart";
import Wishlist from "./Wishlist";
import UserBlock from "./UserBlock";
// import Search from "./Search";
import Vue from "vue";
import gettingRestClientObject from "../../../../services/utils/cms-helper";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
// import ColorPicker from "primevue/colorpicker";
Vue.use(VueMoment, {
  moment,
});
import { deviceType } from "mobile-device-detect";
export default {
  data() {
    return {
      cmsRequestFunctions: null,
      topbarSection: "",
      color: { primary: "283593", accent: "ff5722" },
      Ipaddress: "",
      sessionids: "",
      deviceType: deviceType ? deviceType : "Desktop",
      page: "",
      Language: localStorage.Language ? localStorage.Language : "en",
    };
  },
  components: {
    embMenu: Menu,
    embLang: Lang,
    embCurrency: Currency,
    embCart: Cart,
    embWishlist: Wishlist,
    embUserBlock: UserBlock,
    // ColorPicker,
    // embSearch: Search,
  },
  created() {
    this.$store.dispatch("getProducts");
    this.cmsRequestFunctions = gettingRestClientObject();
  },
  watch: {
    selectedLocale: function () {
      this.$store.dispatch("getProducts");
      this.getPageData();
      this.cmsRequestFunctions.getValidationMsgs();
    },
  },
  computed: {
    ...mapGetters([
      "wishlist",
      "cart",
      "selectCurrency",
      "selectedLocale",
      "products",
      "rtlLayout",
    ]),
  },
  mounted() {
    this.fixedHeader();
    this.getPageData();
    if (sessionStorage.validationItems == undefined) {
      this.cmsRequestFunctions.getValidationMsgs();
    }
  },
  methods: {
    // async login() {
    //   var self = this;
    //   let httpRequestFunctions = gettingHttpFunctions();
    //   var parameters = self.$route.query;
    //   if (parameters.code && parameters.nodeCode) {
    //     if (parameters.code !== localStorage.code) {
    //       localStorage.setItem("code", parameters.code);
    //       localStorage.setItem("nodeCode", parameters.nodeCode);
    //       self.isLoading = true;
    //       var postData = { hqCode: parameters.nodeCode, code: parameters.code };
    //       var config = {
    //         axiosConfig: {
    //           method: "POST",
    //           url: "token",
    //           data: postData,
    //           isBarrerNeeded: false,
    //         },
    //       };
    //       var resp = await httpRequestFunctions.mainAxiosRequest(config);
    //       if (resp !== undefined) {
    //         localStorage.setItem("embryo", JSON.stringify({ user_data: resp }));
    //         self.isLogin = true;
    //         self.userDetail = resp;
    //         self.redirection();
    //         self.$store.dispatch("destroyCartAndWishlist");
    //         self.toCartAndWishlistFromCms();
    //       }
    //       self.isLoading = false;
    //     }
    //   } else {
    //     self.redirection();
    //   }
    // },
    // async toCartAndWishlistFromCms() {
    //   var self = this;
    //   var user = localStorage.getItem("embryo");
    //   var userData = JSON.parse(user);
    //   var userName = userData.user_data.loginId;

    //   var cartItems = [];
    //   var filterValue = "type='Cart' AND keyword1='" + userName + "'";
    //   var allData = await self.cmsRequestFunctions.getDbDataTableValue(
    //     filterValue,
    //     "date1"
    //   );
    //   if (
    //     allData != undefined &&
    //     allData.data != undefined &&
    //     allData.status == 200
    //   ) {
    //     cartItems = allData.data.data;
    //     console.log("Cart items:", cartItems);
    //     cartItems.forEach((element) => {
    //       const cartItem = self.products.find(
    //         (item) => item.Product_Code === element.keyword2
    //       );
    //       if (cartItem) {
    //         const product = cartItem;
    //         this.$store.dispatch("toCart", product);
    //       }
    //     });
    //   } else {
    //     console.log("error:", allData);
    //   }

    //   var wishlistItems = [];
    //   var filterValue2 = "type='WishList' AND keyword1='" + userName + "'";
    //   var allData2 = await self.cmsRequestFunctions.getDbDataTableValue(
    //     filterValue2,
    //     "date1"
    //   );
    //   if (
    //     allData2 != undefined &&
    //     allData2.data != undefined &&
    //     allData2.status == 200
    //   ) {
    //     wishlistItems = allData2.data.data;
    //     console.log("WishList items:", wishlistItems);
    //     wishlistItems.forEach((element) => {
    //       const items = self.products.find(
    //         (item) => item.Product_Code === element.keyword2
    //       );
    //       if (items) {
    //         const product = items;
    //         this.$store.dispatch("toWishlist", product);
    //       }
    //     });
    //   } else {
    //     console.log("error:", allData2);
    //   }
    // },
    colorChange() {
      this.$vuetify.theme.currentTheme.primary = "#" + this.color.primary;
      this.$vuetify.theme.currentTheme.accent = "#" + this.color.accent;
    },
    toggleMobileSidebar() {
      this.$store.dispatch("toggleSidebar", true);
    },
    fixedHeader() {
      var fixedHeader = document.getElementById("fixedHeader");
      window.onscroll = function () {
        if (window.pageYOffset > 160) {
          fixedHeader.style.display = "block";
          fixedHeader.style.opacity = "1";
          fixedHeader.style.visibility = "visible";
          fixedHeader.style.translate = "translateY(0)";
          fixedHeader.style.top = 0;
        } else {
          fixedHeader.style.display = "none";
          fixedHeader.style.opacity = "0";
          fixedHeader.style.visibility = "hidden";
          fixedHeader.style.translate = "translateY(-200px)";
          fixedHeader.style.top = "0";
        }
      };
    },
    // redirection() {
    //   var user = localStorage.getItem("embryo");
    //   var userData = JSON.parse(user);
    //   if (userData) {
    //     var useDetails = userData.user_data;
    //     if (!useDetails.isPhoneNumberVerified) {
    //       this.$router.push({ path: "/account/profile" });
    //     }
    //   }
    // },
    getPageData: function () {
      var self = this;

      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "01 Top Bar/01 Top Bar/01 Top Bar.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var topbarArea = self.cmsRequestFunctions.pluck(
              "Top_Bar_Section",
              res.area_List
            );
            self.topbarSection = self.cmsRequestFunctions.getAllMapData(
              topbarArea[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
    changeLanguage() {
      var self = this;
      self.getPageData();
      self.$refs.menubar.getPageData();
    },
  },
};
</script>



